import { render, staticRenderFns } from "./DrivesExamResults.vue?vue&type=template&id=a92c52a6&"
import script from "./DrivesExamResults.vue?vue&type=script&lang=js&"
export * from "./DrivesExamResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports